import { combineReducers } from 'redux';

import slices from './slices';

export const reducers = {
  posts: slices.postsSlice.reducer,
  chats: slices.chatsSlice.reducer,
  active: slices.activeSlice.reducer,
  chatMessages: slices.chatMessagesSlice.reducer,
};

const reducer = combineReducers({
  posts: reducers.posts,
  chats: reducers.chats,
  active: reducers.active,
  chatMessages: reducers.chatMessages,
});

export default reducer;
